import React, { useState, useEffect } from 'react';
import { database } from '../../supabase';

interface UserProfile {
  id: string;
  user_id: string;
  first_name?: string;
  last_name?: string;
  role: string;
  created_at: string;
}

const UserManager: React.FC = () => {
  const [users, setUsers] = useState<UserProfile[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    loadUsers();
  }, []);

  const loadUsers = async () => {
    try {
      setLoading(true);
      const { data, error } = await database.getAllUsers();
      if (error) throw error;
      setUsers(data || []);
    } catch (err) {
      setError('Failed to load users');
    } finally {
      setLoading(false);
    }
  };

  const handleSetUserRole = async (userId: string, role: string) => {
    try {
      const { error } = await database.setUserRole(userId, role);
      if (error) throw error;
      await loadUsers();
    } catch (err) {
      alert('Failed to update user role');
    }
  };

  if (loading) {
    return <div className="loading">Loading users...</div>;
  }

  if (error) {
    return <div className="error">Error: {error}</div>;
  }

  return (
    <div className="users-section">
      <div className="section-header">
        <h2>User Management</h2>
      </div>

      <div className="users-table">
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Role</th>
              <th>Created</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.map(user => (
              <tr key={user.id}>
                <td>{user.first_name} {user.last_name}</td>
                <td>{user.user_id}</td>
                <td>
                  <select
                    value={user.role}
                    onChange={(e) => handleSetUserRole(user.user_id, e.target.value)}
                  >
                    <option value="customer">Customer</option>
                    <option value="admin">Admin</option>
                  </select>
                </td>
                <td>{new Date(user.created_at).toLocaleDateString()}</td>
                <td>
                  <button
                    onClick={() => handleSetUserRole(
                      user.user_id,
                      user.role === 'admin' ? 'customer' : 'admin'
                    )}
                    className={user.role === 'admin' ? 'demote-btn' : 'promote-btn'}
                  >
                    {user.role === 'admin' ? 'Remove Admin' : 'Make Admin'}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UserManager;
